<template>
  <div>
    <b-modal
      v-model="showModal"
      centered
      header-class="custom-modal-header"
      footer-class="custom-modal-footer"
      size="xl"
    >
      <template #modal-header>
        <p class="text-header">เพิ่มสินค้า</p>
      </template>
      <div class="main-theme">
        <b-table
          class="table-list"
          striped
          responsive
          hover
          :items="productList"
          :fields="fields"
          :busy="isBusy"
          show-empty
          :empty-text="$t('noData')"
        >
          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <b-form-group class="cb-table mb-0 ml-3">
              <b-form-checkbox
                :value="data.item.id"
                :disabled="
                  productSelected.length == 9 &&
                  !productSelected.includes(data.item.id)
                "
                v-model="productSelected"
              ></b-form-checkbox>
            </b-form-group>
          </template>
          <template v-slot:cell(imageUrl)="data">
            <div class="position-relative picture-text pic-table">
              <div
                v-if="data.item.imageUrl"
                class="square-box b-contain pic-box"
                v-bind:style="{
                  'background-image': 'url(' + data.item.imageUrl + ')',
                }"
              ></div>
              <div v-else>-</div>
            </div>
          </template>
          <template v-slot:cell(name)="data">
            <div class="text-left">
              <p class="m-0" v-if="data.item.name">
                {{ data.item.name }}
              </p>
              <p class="m-0 text-gray" v-if="data.item.name">
                {{ data.item.sku }}
              </p>
              <p v-else class="m-0">-</p>
            </div>
          </template>
          <template v-slot:cell(barcode)="data">
            <p class="m-0" v-if="data.item.barcode">
              {{ data.item.barcode }}
            </p>
            <p v-else class="m-0">-</p>
          </template>

          <template v-slot:cell(price)="data">
            <p class="m-0 price-text" v-if="data.item.price">
              ฿ {{ data.item.price | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
        </b-table>
        <div class="d-flex justify-content-between">
          <div class="text-error my-auto" v-if="isError">
            กรุณาเลือกสินค้าอย่างน้อย 1 รายการ
          </div>
          <div class="d-sm-flex mx-3 ml-auto">
            <b-pagination
              v-model="productFilter.pageNo"
              :total-rows="rows"
              :per-page="productFilter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <b-button
            :disabled="isDisable"
            @click="hide"
            class="btn-details-set btn-cancel"
            >CANCEL</b-button
          >

          <button
            type="button"
            @click="checkForm()"
            :disabled="isDisable"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            Confirm
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    productSelectedList: {
      required: false,
      type: Array,
    },
  },
  data() {
    return {
      productFilter: {
        Categories: [],
        pageNo: 1,
        perPage: 5,
        productIdList: [],
        searech: "",
      },
      isDisable: false,
      isBusy: false,
      rows: 0,
      productSelected: [],
      productList: [],
      showModal: false,
      isError: false,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      fields: [
        {
          key: "id",
          label: "",
        },
        {
          key: "imageUrl",
          label: "รูปภาพ",
          class: "w-100px",
        },
        {
          key: "name",
          label: "ชื่อสินค้า (SKU)",
          class: "w-100px",
        },
        {
          key: "barcode",
          label: "บาร์โค้ด",
          class: "w-100px",
        },
        {
          key: "price",
          label: "ราคา",
          class: "w-100px",
        },
      ],
    };
  },
  validations: {},
  methods: {
    checkForm: async function () {
      if (this.productSelected.length > 0) {
        this.isError = false;
        let dataList = [];
        if (this.productSelectedList.length > 0) {
          this.productSelected.forEach((element) => {
            let data = {};
            this.productSelectedList.forEach((element2) => {
              if (element == element2.Id) {
                data = {
                  Id: element2.Id,
                  ProductId: element2.ProductId,
                  SortOrder: dataList.length + 1,
                };
              } else {
                data = {
                  Id: 0,
                  ProductId: element,
                  SortOrder: dataList.length + 1,
                };
              }
            });
            dataList.push(data);
          });
        } else {
          dataList = this.productSelected.map((element, index) => {
            return {
              Id: 0,
              ProductId: element,
              SortOrder: index + 1,
            };
          });
        }

        this.$emit("onSetSubmitProductSelected", dataList);
        this.hide();
      } else {
        this.isError = true;
      }
    },
    pagination(Page) {
      this.productFilter.pageNo = Page;
      this.getProductList();
    },
    setProductSelected() {
      this.productSelected = this.productSelectedList.map((el) => el.ProductId);
    },
    getProductList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/product/list`, this.productFilter)
        .then((data) => {
          if (data.result == 1) {
            this.productList = data.detail.dataList;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    show: async function () {
      await this.getProductList();
      await this.setProductSelected();
      this.showModal = true;
    },
    hide() {
      this.productSelected = [];
      this.productFilter = {
        Categories: [],
        pageNo: 1,
        perPage: 5,
        productIdList: [],
        searech: "",
      };
      this.rows = 0;
      this.productList = [];
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.pic-table {
  width: 70px;
  height: 70px;
  margin: auto;
  display: flex;
}
</style>
